import React from "react";
import {
  Accordion,
  AccordionItem,
  AccordionTrigger,
  AccordionContent,
} from "../ui/accordion";
import { Card } from "../ui/card";
import { FileText } from "lucide-react";
import { Page } from "components/ui/page";
import PageHeader from "components/ui/PageHeader";

const DocumentView = () => {
  const documentation = [
    {
      question: "Template",
      answer:
        "With Templates, you can build professional marketing emails without having any HTML skills. Templates helps you make attractive, professional-looking email campaigns that fit any screen size or mobile device.",
    },
    {
      question: "Targets",
      answer:
        "Multi lead feature and a system that's been proven to improve conversion rates, most powerful tool for generating leads of any kind. Add to that our competitively priced packages and it's easy to see why our customer leads are quickly becoming the go-to source for companies who want more qualified prospects and better conversion rates.",
    },
    {
      question: "Leads",
      answer:
        "ImportLeads is an automated email tool that takes the pain out of email marketing. With Importleads, you'll be able to create campaigns with a wide variety of templates. Campaigns can be set up for high visibility and open rates so you can promote products or raise awareness about new products and services.",
    },
    {
      question: "Analytics",
      answer:
        "A marketing dashboard can be used for a variety of purposes, including analyzing marketing efforts, measuring success, and making business decisions. It includes an analytics feature that benefits marketers, dashboard provides insight into campaign effectiveness.",
    },
  ];

  return (
    /* Same one-off header as Feedback had — replaced with the shared anatomy. */
    <Page width="narrow">
      <PageHeader
        icon={<FileText className="w-5 h-5" />}
        tone="brand"
        title="Documentation"
        subtitle="Learn how to use this tool effectively"
      />

        {/* Documentation Accordion */}
        <Card>
          <Accordion type="single" collapsible defaultValue="item-0" className="w-full">
            {documentation.map((item, index) => (
              <AccordionItem key={index} value={`item-${index}`}>
                <AccordionTrigger className="text-lg font-semibold">
                  {item.question}
                </AccordionTrigger>
                <AccordionContent className="text-base leading-relaxed">
                  {item.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Card>

        {/* Additional Info */}
        <div className="mt-8 bg-blue-50 dark:bg-blue-900/20 rounded-lg p-6 border border-blue-200 dark:border-blue-800">
          <h3 className="text-lg font-semibold text-content dark:text-white mb-3">
            Need More Help?
          </h3>
          <p className="text-content-secondary dark:text-gray-400 mb-4">
            If you have questions that aren't covered in this documentation, feel
            free to reach out to our support team.
          </p>
          <p className="text-content-secondary dark:text-gray-400">
            We're here to help you get the most out of our platform!
          </p>
        </div>
    </Page>
  );
};

export default DocumentView;
